import { fixedOperators } from './data/google/processor/data_char2fixedOperators.mjs';
import { dialogNpcByName } from './data/google/processor/data_dialogNpcs.mjs';
import characterNames from './data/google/downloaded/char2characterNames.json' assert { type: 'json' };

export const names = ['James', 'Robert', 'John', 'Michael', 'David', 'William', 'Richard', 'Joseph', 'Thomas', 'Charles', 'Christopher', 'Daniel', 'Matthew', 'Anthony', 'Mark', 'Donald', 'Steven', 'Paul', 'Andrew', 'Joshua', 'Kenneth', 'Kevin', 'Brian', 'George', 'Timothy', 'Ronald', 'Edward', 'Jason', 'Jeffrey', 'Ryan', 'Jacob', 'Gary', 'Nicholas', 'Eric', 'Jonathan', 'Stephen', 'Larry', 'Justin', 'Scott', 'Brandon', 'Benjamin', 'Samuel', 'Gregory', 'Alexander', 'Frank', 'Patrick', 'Raymond', 'Jack', 'Dennis', 'Jerry', 'Tyler', 'Aaron', 'Jose', 'Adam', 'Nathan', 'Henry', 'Douglas', 'Zachary', 'Peter', 'Kyle', 'Ethan', 'Walter', 'Noah', 'Jeremy', 'Christian', 'Keith', 'Roger', 'Terry', 'Gerald', 'Harold', 'Sean', 'Austin', 'Carl', 'Arthur', 'Lawrence', 'Dylan', 'Jesse', 'Jordan', 'Bryan', 'Billy', 'Joe', 'Bruce', 'Gabriel', 'Logan', 'Albert', 'Willie', 'Alan', 'Juan', 'Wayne', 'Elijah', 'Randy', 'Roy', 'Vincent', 'Ralph', 'Eugene', 'Russell', 'Bobby', 'Mason', 'Philip', 'Louis'];

export const names_cute = [
  "나가토미 하스미",
  "나카노 유카",
  "니와 히토미",
  "도묘지 카린",
  "마나카 미사토",
  "마에카와 미쿠",
  "마츠바라 사야",
  "모모이 아즈키",
  "모치다 아리사",
  "무나카타 아츠미",
  "무라마츠 사쿠라",
  "미무라 카나코",
  "미야모토 프레데리카",
  "미즈모토 유카리",
  "사이온지 코토카",
  "사카키바라 사토미",
  "사쿠라이 모모카",
  "사쿠마 마유",
  "세키 히로미",
  "스즈미야 세이카",
  "시라기쿠 호타루",
  "시라유키 치요",
  "시마무라 우즈키",
  "시이나 노리코",
  "아리우라 칸나",
  "아베 나나",
  "아사노 후카",
  "아이하라 유키노",
  "아카니시 에리카",
  "안자이 미야코",
  "야나기 키요라",
  "야나세 미유키",
  "야오 페이페이",
  "에가미 츠바키",
  "오가타 치에리",
  "오오누마 쿠루미",
  "오오니시 유리코",
  "오오타 유우",
  "오오하라 미치루",
  "오쿠야마 사오리",
  "오토쿠라 유우키",
  "요코야마 치카",
  "유사 코즈에",
  "이가라시 쿄코",
  "이마이 카나",
  "이무라 세츠나",
  "이치노세 시키",
  "이케부쿠로 아키하",
  "츠지노 아카리",
  "츠키미야 미야비",
  "코가 코하루",
  "코바야카와 사에",
  "코시미즈 사치코",
  "코히나타 미호",
  "쿠도 시노부",
  "쿠리하라 네네",
  "쿠로사키 치토세",
  "쿠사카베 와카바",
  "클라리스",
  "하라다 미요",
  "하야사카 미레이",
  "효도 레나",
  "후지모토 리나",
  "후쿠야마 마이",
  "후타바 안즈",
];

export const names_cool = [
  "나루미야 유메",
  "니노미야 아스카",
  "니시카와 호나미",
  "닛타 미나미",
  "라이라",
  "마츠나가 료",
  "마츠모토 사리나",
  "마츠오 치즈루",
  "모리쿠보 노노",
  "모치즈키 히지리",
  "미즈노 미도리",
  "미즈키 세이라",
  "미후네 미유",
  "사기사와 후미카",
  "사사키 치에",
  "사죠 유키미",
  "세나 시오리",
  "스나즈카 아키라",
  "시노하라 레이",
  "시라사카 코우메",
  "시부야 린",
  "시오미 슈코",
  "아나스타샤",
  "아라키 히나",
  "아사리 나나미",
  "아야세 호노카",
  "아이카와 치나츠",
  "야가미 마키노",
  "야마토 아키",
  "오오이시 이즈미",
  "오카자키 야스하",
  "와쿠이 루미",
  "와키야마 타마미",
  "요시오카 사키",
  "우메키 오토하",
  "우지이에 무츠미",
  "유우키 하루",
  "이쥬인 메구미",
  "카미야 나오",
  "카미죠 하루나",
  "카와시마 미즈키",
  "칸자키 란코",
  "케이트",
  "코무로 치나미",
  "쿠로카와 치아키",
  "키류 츠카사",
  "키리노 아야",
  "키바 마나미",
  "키시베 아야카",
  "타다 리이나",
  "타치바나 아리스",
  "타카가키 카에데",
  "타카미네 노아",
  "타카하시 레이코",
  "타카후지 카코",
  "토고 아이",
  "하야미 카나데",
  "핫토리 토코",
  "헬렌",
  "호죠 카렌",
  "후루사와 요리코",
  "후지와라 하지메",
  "후지이 토모",
  "히사카와 하야테",
  "히이라기 시노",
];

export const names_passion = [
  "나미키 메이코",
  "나탈리아",
  "난죠 히카루",
  "남바 에미",
  "노노무라 소라",
  "니시지마 카이",
  "류자키 카오루",
  "마나베 이츠키",
  "마츠야마 쿠미코",
  "마키하라 시호",
  "마토바 리사",
  "메어리 코크란",
  "모로보시 키라리",
  "무라카미 토모에",
  "무카이 타쿠미",
  "미요시 사나",
  "사에지마 키요미",
  "사와다 마리나",
  "사이토 요코",
  "사토 신",
  "센자키 에마",
  "소마 나츠미",
  "슈토 아오이",
  "스기사카 우미",
  "아이노 나기사",
  "아이바 유미",
  "아카기 미리아",
  "야구치 미우",
  "에비하라 나호",
  "에토 미사키",
  "오오츠키 유이",
  "오이카와 시즈쿠",
  "와카바야시 토모카",
  "요리타 요시노",
  "우에다 스즈호",
  "유메미 리아무",
  "이브 산타클로스",
  "이치하라 니나",
  "자이젠 토키코",
  "죠가사키 리카",
  "죠가사키 미카",
  "츠치야 아코",
  "카타기리 사나에",
  "캐시 그라함",
  "코마츠 이부키",
  "코세키 레이나",
  "키무라 나츠키",
  "키타 히나코",
  "키타가와 마히로",
  "키타미 유즈",
  "타카모리 아이코",
  "토토키 아이리",
  "하마구치 아야메",
  "하마카와 아유나",
  "호시 쇼코",
  "혼다 미오",
  "히노 아카네",
  "히메카와 유키",
  "히사카와 나기",
];

export const names2_cats = {
  'cool': names_cool,
  'cute': names_cute,
  'passion': names_passion,
};

export const names2 = Object.values(names2_cats).flat();
export const names3 = [
  'Rodrigo Vargas',
  'Carlos Perez',
  'Mauricio Rey',
  'Emilio Torres',
  'Arturo Sanchez',
  'Rafael Medina',
  'Cristobal Oliveira',
  'Jesus Jimenez',
  'Lorenzo Sosa',
  'Antonio Luis',
  'Felipe Cerna',
  'Ernesto Cuevas',
  'Raul Mendoza',
  'Juan Guzman',
  'Guillermo Navarro',
  'Sergio Escobar',
  'Pablo Castillo',
  'Hector Paredes',
  'Marco Ramirez',
  'Fernando Garcia',
  'Santiago Rodriguez',
  'Cesar Contreras',
  'Alejandro Morales',
  'Diego Cortez',
  'Francisco Ortega',
  'Vicente Suarez',
  'Oscar Ochoa',
  'Ricardo Vega',
  'Ignacio Molina',
  'Alejandro Moreno',
  'Luis Martinez',
  'Marcelo Pereira',
  'Julio Guerrero',
  'Benjamin Silva',
  'Victor Cardenas',
  'Angel Fuentes',
  'Joaquin Saavedra',
  'Jose Aguirre',
  'Mateo Sepulveda',
  'Alberto Valdez',
  'Alfonso Vasquez',
  'Eduardo Delgado',
  'Leon Zamora',
  'Gonzalo Leiva',
  'Roberto Soto',
  'Gabriel Rosales',
  'Andres Salazar',
  'Miguel Herrera',
  'Enrique Arias',
  'Esteban Tapia',
  'Manuel Nunez',
  'Patricio Parra',
  'Pedro Lira',
  'Jaime Diaz',
  'Orlando Pino',
  'Nicolas Vidal',
  'Ramon Guerra',
  'Armando Serrano',
  'Camilo Orellana',
  'Walter Espinoza',
  'Juan Carlos Cortes',
  'Ruben Cordero',
  'Fernando Oliva',
  'Omar Barra',
  'Mario Paredes',
  'Carlos Pizarro',
  'Ariel Quiroga',
  'Guillermo Manrique',
  'Cristian Mora',
  'Diego Velasquez',
  'Ricardo Ocampo',
  'Rodrigo Chavez',
  'Ezequiel Cifuentes',
  'Gerardo Cuello',
  'Gonzalo Urrutia',
  'Hernan Vasco',
  'Ignacio Pena',
  'Javier Caicedo',
  'Jonathan Lugo',
  'Leonardo Aldana',
  'Leopoldo Tejada',
  'Luis Alberto Leon',
  'Marcos Quintana',
  'Martin Pacheco',
  'Mauricio Ibarra',
  'Max Yanez',
  'Nelson Zuniga',
  'Octavio Velez',
  'Ramiro Caceres',
  'Raul Suarez',
  'Ricardo Mendez',
  'Roman Cabrera',
  'Sebastian Molina',
  'Sergio Montenegro',
  'Tomas "Tsunami"',
  'Uriel Segovia',
  'Victor Hugo Villalba',
  'Wilfredo Ramirez',
  'Xavier Godoy',
  'Yerko Valenzuela',
  'Alejandro Aguilera',
  'Alvaro Fajardo',
  'Anibal Ortega',
  'Antonio Jara',
  'Ariel Beltran',
  'Arturo Salinas',
  'Bernardo Vallejos',
  'Bruno Montoya',
  'Camilo Guzman',
  'Cesar Maldonado',
  'Clemente Peralta',
  'Cristobal Ayala',
  'Damian Barrientos',
  'Daniel Linares',
  'Dario Poblete',
  'David Del Rio',
  'Edmundo Ballesteros',
  'Eladio Carvajal',
  'Elias Barrios',
  'Emilio Tapia',
  'Enrique Morales',
  'Ernesto Cazares',
  'Esteban Sandoval',
  'Eugenio Vega',
  'Fabian Tellez',
  'Felipe Salgado',
  'Fermin Barriga',
  'Francisco Mendoza',
  'Gabriel Medina',
  'Geronimo Canales',
  'Gustavo Palacios',
  'Hector Carrasco',
  'Hugo Montes',
  'Humberto Navarrete',
  'Ignacio Perez',
  'Ivan Vargas',
  'Jeronimo Moya',
  'Joaquin Moncada',
  'Jorge Benavides',
  'Jose Valdivia',
  'Juan Rios',
  'Juan Pablo Oviedo',
  'Julio Cesar Araya',
  'Leandro Sosa',
  'Lorenzo Munoz',
  'Luciano Carreno',
  'Manuel Cifuentes',
  'Marcos Riquelme',
  'Mario Gallardo',
  'Matias Paredes',
  'Mauricio Vera',
  'Maximo Palma',
  'Miguel Angel Aguirre',
  'Nestor Guerrero',
  'Nicolas Baeza',
  'Norberto Caceres',
  'Orlando Aravena',
  'Oscar Roldan',
  'Osvaldo Pereira',
  'Pablo Cardenas',
  'Patricio Fuentes',
  'Paul Saavedra',
  'Pedro Aguirre',
  'Rafael Sepulveda',
  'Raul Valdez',
  'Rene Vasquez',
  'Ricardo Delgado',
  'Roberto Zamora',
  'Rodolfo Leiva',
  'Rogelio Soto',
  'Romulo Rosales',
  'Ruben Salazar',
  'Samuel Herrera',
  'Santiago Arias',
  'Sergio Tapia',
  'Simon Nunez',
  'Tomas Parra',
  'Vicente Lira',
  'Victor Diaz',
  'Washington Pino',
  'Wilfredo Vidal',
  'Ximeno Guerra',
  'Yamil Serrano',
  'Yerko Orellana',
  'Zeno Espinoza',
  'Abel Cortes',
  'Adan Cordero',
  'Adolfo Oliva',
  'Adrian Barra',
  'Agustin Paredes',
  'Aitor Pizarro',
  'Alain Quiroga',
  'Alan Manrique',
  'Alberto Mora',
  'Alejandro Velasquez',
  'Alex Ocampo',
  'Alfredo Chavez',
  'Alvaro Cifuentes',
  'Amadeo Cuello',
  'Amador Urrutia',
];

export const names4 = Object.values(fixedOperators).map((e) => e.name);
export const names5 = Object.values(characterNames).map((e) => e.name);

const images = [
  {
    "name": "시마무라",
    "src": "4IMJTTSwPpZVvR4munGRiNRKTaR3YM0XSa8ttEbrXgZNY1SSo7wCQMXS3vfukqOUGRxWjyDuFbY1CBXqWejRXA.webp"
  },
  {
    "name": "나카노 ",
    "src": "1GDDmhAfaNVWTjs2xCmFwsQy7RMs1fECQxGUa9f1LQWxGpCLJGQQhgsMY3fEuYQujr2oEyoro3XfaP4zfdJOdA.webp"
  },
  {
    "name": "미즈모토",
    "src": "yDCVTAN7aNsAeJqSsDpB5fyr8dGKIIJTddrOCyv5dZuYPsokK9b-71t1qZ9jbK13D-IXqI8k7DFOKAPtImJVzA.webp"
  },
  {
    "name": "후쿠야마",
    "src": "F4_AY1PHzweA68LeQoHqSYV2aBpmEAf-Ir3nnO0NPn-RP1I4nMCoQMLly78lEaaVf-PsNSLNXPkuQAAA0qONXw.webp"
  },
  {
    "name": "시이나 ",
    "src": "oMC5qbxZvgotEemXB4y0wWRe_hisPflU3KMqVXF9bqgLU7fO6f7uP5heIa7jI747cnYXHjzGo6l8wJw_oQzleA.webp"
  },
  {
    "name": "이마이 ",
    "src": "reBHbTikfiAYSalItgpX2OHI135GnavXyXcW_oCjASWApWQYrzPFOZPx-0XqdCdAbf6IE_AA3rvv_df6NDaNsw.webp"
  },
  {
    "name": "모치다 ",
    "src": "0cKqJ7ZmWjWKUbeJJ25xkFxtbB5luP4gOpJoawN369qkvw_iYxVhNfY_YX4JUZ877pHiXPoJcCOLf_5IgeWIpQ.webp"
  },
  {
    "name": "미무라 ",
    "src": "6WTkzYyKTexNHhyoWvHAR2Eh3og5Pe-_ubzY_B1z6M2ucF9FgE9_BrzWiWtjbXr0_yBq41OtmN1guq_kXzGvXg.webp"
  },
  {
    "name": "오쿠야마",
    "src": "vrc7W8uDK5ubom8lo6x-VLYs6reNpvNx1gn7KdDO7EAvwAorqymLL-J9iL3EdkJh_PpoyzsMlRyL8YdkLydr5Q.webp"
  },
  {
    "name": "마나카 ",
    "src": "RKbeymdUchprcwdu7wD7fe_o45svP4cSeKGcr_2d30cuYJa61TkK4T3U3KPcBVwyTbZrzsHft17R7rPIPYngSQ.webp"
  },
  {
    "name": "코히나타",
    "src": "9qOCCAMcMFUYtvZ_TaOegiOgF0yqxVvpbGJUP2dnPm4SD58xYY7UVdGKjMGJVqfzuVAZm0wyqx127Kec12537Q.webp"
  },
  {
    "name": "오가타 ",
    "src": "wnD4YMXTEreZrWih3E9iwukJ46FvA2PeKkECwKhH0dnQksKuxLYmH7_Yq2ciL4gxhtXTpfYPZv8XxgwobfcQhQ.webp"
  },
  {
    "name": "이가라시",
    "src": "lxl7rblMt0qi6D3f17kPCx34lpk1u-aIZ1RocN2mEhTvhv1rK5VQ239fJUJKqCi0BPmrZ_dkfFsc5xd-Gje4xQ.webp"
  },
  {
    "name": "야나세 ",
    "src": "tmTglWWE4LrSOkkvWfeK74tUaIb4YOxgsXrsVdJXaGwMu3Y1vG4CsxFi5BeFnCOJUUQ7aVZ8yLmMTGaS9MDmVg.webp"
  },
  {
    "name": "사쿠라이",
    "src": "QT2_YPBtlj9JpvJCNGlnbCapa-d4Ugwvw8rce35xCSDgPQVyjGIqxDFdIfkwSxCp0tHjkNGAnfNC-ORHOANLVQ.webp"
  },
  {
    "name": "에가미 ",
    "src": "-falwWWXCmLmLjUf_G2ujniikze0GvDf90cWJxUs4_-1eKAriY1aLI6Qp71Rz2S-GTmpqiK9awiwOs0T80D7Hg.webp"
  },
  {
    "name": "나가토미",
    "src": "XfHDrS9v0Qudlqt7FqAmWVH9C_ysPgGYQWbKd8KQ4-hS5kdW64lDdUcl85diiHF_99aKVL-R5jVLTEM9_12KJA.webp"
  },
  {
    "name": "요코야마",
    "src": "PKnXp9xpo9ucFiG0up3aImx4ijqKy6fvOg3oCCfXK9YgLHKxzdI_MePOTUtJdTBd380g6hsrJhpBhghCyySQ9Q.webp"
  },
  {
    "name": "세키 히",
    "src": "p8q0ia-m6mt7L14b5_Ttq8mqDs9XA63tIlG494THo0pm0uGc01RPTdapW42j-DHA9urIYm3Rp_s18jFpOE_KhA.webp"
  },
  {
    "name": "오오타 ",
    "src": "UkEDJc1H-Kx8MaZTMF_mR1DuYQgvwMk1xUB7UQSsNfQiWPaBv_9OkZm3Ta12ehi3aCUhLnbnPSLlKOQd1iw-yA.webp"
  },
  {
    "name": "무나카타",
    "src": "aw55PFDBXEzsxm3S3mK7EBmQdNtp3zU92SY0Yy90IVxA6VV7__BY-INGAkPPBPcgiheLuVTYjd0VZTr10aAVJg.webp"
  },
  {
    "name": "후지모토",
    "src": "DznANrRGO4xaIwo-fwfqTLlaMZnjsNyZOrWTq8B-DGkTywpc2khFSyGn3FvNKo3hk93y95wiASigDNOab4SZIQ.webp"
  },
  {
    "name": "오오하라",
    "src": "38l9gUG-v14kL4O3kcQMN-OoJMYRjvsn33kVIhUwjk_MFNi2Wp4S_98c-iGiWAXfY0qbUI8NsI6-5nQ1ZBr3aQ.webp"
  },
  {
    "name": "유사 코",
    "src": "m8Mq7XsiQezsrGNi2kzMQoayy8xhZ0bn547SkWrH2beVA2eW1OBRdyj5jPougFlOf5vynYfPtSsmnj_cN3fD_A.webp"
  },
  {
    "name": "오오누마",
    "src": "nUEYZ7H-7wxaW-Sn2P6bwEfpapNfwY80czw3Re0Gn_UwJ5_tDHkvTuS7epQFeP0GHYr8js85mhXfa3RLzcpaWw.webp"
  },
  {
    "name": "이치노세",
    "src": "xSVN1MacagS29M4RvnV-Tby_r6egLPELItf8ZEu0DqvEgrVCfWR0muWT4oopLv6znTCU02bdBqlH4_4p9zXIRQ.webp"
  },
  {
    "name": "마에카와",
    "src": "q6KpShH03pj6RnAv_R6izxuE0Wh4erbyE7PRp4laMzFaxrZ_lneg6fY-KRpZd5G3SOLZGANNkG9gm6_5FuFRVA.webp"
  },
  {
    "name": "아카니시",
    "src": "BKnOGdV83e0E9sySb4g_Pc0iYz0GBJYmmYWc_3p8j1a_R8eJK7Copb14KculOh-K1m-jbHbWJwsjByJfPS5Ewg.webp"
  },
  {
    "name": "마츠바라",
    "src": "_DgU4Hg4Z0g59-dpzkM65BKnac2tpo_pgJTYb56wzCmQdh2vI2PiIQ7kv1IZpPB77Jk9_OEZcC_Xy-APrD72Tw.webp"
  },
  {
    "name": "아이하라",
    "src": "sqgAHyNgC7R_o0T5Ewx-I1s9MBSlbPOTfPOOOf-sBrp1W9XtJ6bpf5JhtSxykyBCMha8HoZIWpfD1Ox23lpI2Q.webp"
  },
  {
    "name": "미야모토",
    "src": "amTtlo3ioMwsDUJbAxXADjrDp1ClFlNqsh7aBlaFTnzJrfvlYgiycwiHQfqzuvPAgY6XTorCX0_GVamhEXYciA.webp"
  },
  {
    "name": "코바야카",
    "src": "m1cOshGoceEgYDoSNdue9_kfCFetaoDl0pWK1ThFPLWBzma5_Mgg53ksG3XzjrUKA6TMC_4Q5pbK3gdNJcDX1w.webp"
  },
  {
    "name": "사이온지",
    "src": "mZUAVEobJRFOBAcvxxy6qYRRneihQE_-HgumPVdGtAJ8LYGWj4k3aRgWcT3snbB3iAsgDEraXgD9Gnd8a_Q3Gg.webp"
  },
  {
    "name": "후타바 ",
    "src": "RX45XQ9JGJNLuFUXkCvRVBlUWp_seVxE3UtPc1HiFTuoJHB9ntorUtDAiNPtVK7PphfSsTvzKW-aTej1qqeO6w.webp"
  },
  {
    "name": "야오 페",
    "src": "_EEo12Gw1LTS9gabmwOsFqcc0PQroVPPqy4VtDPU6IGDy4W8bBztxREKMzLzvKU4OY_j9YYFlOdVKIaYJk0kOQ.webp"
  },
  {
    "name": "모모이 ",
    "src": "6DS7MMcgJs_8T5jbQFfKTEfmH_-W7hBnlzskKEjSiVy_Ia2P6KzZE5jQ2zOoWadzmb35rNE2ev42WVMZX1zF-w.webp"
  },
  {
    "name": "스즈미야",
    "src": "JThkcPZ6gxY6tLfFEmjMMxoT80bs-dOf8NxGw-UeUtxpgIcaHbRFd7R2NhN_pbYnEAle_NaBIDw_ph-5a9PRMg.webp"
  },
  {
    "name": "츠키미야",
    "src": "JAi1iwBCPp1BZ7qHfQ2og5jgyufxR52r6FmIwJZHCz7umSlv4YX911Hf3FMdaIEieHJg_NOIAq8dRPcJXvNUjA.webp"
  },
  {
    "name": "효도 레",
    "src": "-FX8ARy12pV9GQsgb-G9lIlTECd_YOrBBXrCyeC7kBfg9yBYroIFMBgxnxUg4HNukKb84o5M9DbFjJdzxJKI7Q.webp"
  },
  {
    "name": "니와 히",
    "src": "kdvWL8bdzB5k4pu2CLRPD42kNznT34MztqEnFRaev64zDfMSHGkteot--zNhXxepZ1tZbc9QBuHlE6-EuQryRg.webp"
  },
  {
    "name": "도묘지 ",
    "src": "Q_zQ8fqRz9LiSljcGQAYna9mR5uQWG-aT6-V438ekrfxXPqlteSOuJm3syckx7dte8Sf4gX7k29k01mGYd1lTA.webp"
  },
  {
    "name": "야나기 ",
    "src": "6gjvbtvVPr9KmSdDu8sLhfnOnd19wh2Gp6zgJPYZSiZJzIlNSgJ0ooLsDwbUVpCPGxu0mF05LHRweEhfMarkyw.webp"
  },
  {
    "name": "이무라 ",
    "src": "kkOeGVF2OQ_YsyKu1bCp8u3DNZqSiokK4byecCzaVtsOOvcMpDy5LrZpf8mdpF6KsQuq_rsjRATqui4XgKoYCQ.webp"
  },
  {
    "name": "쿠사카베",
    "src": "hpiIDtVuA9CSNiIhMWkBLcu1_dzBPcKdeZbXPC3SAoDQqOsoAPs22uLRU2KN5wHuwUHuB7mYESzGU5KyWbzbOA.webp"
  },
  {
    "name": "사카키바",
    "src": "Jtf1jDgMISwFlwB9A2UnEgVnL-6m-cItdTYp-KnlJZvYnsa7vQ7GBcQULDw3v0hZ4qY3ZKnC8FRKC-tW-SiApw.webp"
  },
  {
    "name": "코시미즈",
    "src": "pU2LUyY1XwXFBzFsnLuzQr8jmHt3Db8BEnUKlH_JbMraiNxWyaxZ5R9pTA9qmmv3i_o53Dhgtno4hbW4CyTT_Q.webp"
  },
  {
    "name": "안자이 ",
    "src": "fIdaYkNTPZTOQxYJ6wV0LnPlaUqKqI3DHnDhF86pidDL0mL_4JP4MRliyzLI4HAGPcuXkd-r4E2D3Zd8m8gWkA.webp"
  },
  {
    "name": "아사노 ",
    "src": "SUe7jrPy_BJVU5vjvgv-WSx4rZo5_OmZnPnE5JFLjrcaNXZ--OH1ENzI-ofspUFbxktb3ZqfC_CQ7ljLkliw4g.webp"
  },
  {
    "name": "오오니시",
    "src": "Ih2wzyHs4bW89UVz0L4MuVDjhtPmUzO5v9lj1aix3SN5kWnucoLO10KhJw_V4L6CEPhjZ34Y0KBjejN0TlhCww.webp"
  },
  {
    "name": "아베 나",
    "src": "MloqUZhg6tYSAbd01hIjDGxuy8K4A0kTczGUGe6UTlUZ24qFxLQXVpYzMo_sGjf9fPgZC-3lb-aVaKOmvhogNA.webp"
  },
  {
    "name": "쿠도 시",
    "src": "qCnpNybUD424H9CjhC1SC6CfGeH9sNuYB9ZFcJyPYhhCvLmnC_E5LMKEPZTAihjpKEM3QMrF4Z4fbhvwLr4-Hg.webp"
  },
  {
    "name": "쿠리하라",
    "src": "bO6BW_naklGFaedlNpMz3iUpaFCo3WxaBweHv3hmBpxLuUTYr8LYaBXqGPCqzSrIdXV3-MXp5lZ_bUzp6BUSvA.webp"
  },
  {
    "name": "코가 코",
    "src": "9X1KyLkpBfca_sh_1jE82FRBXGdhBVtKQTcRDvDHGrW-bMH7s896kKHeseCBbS1LLgYbLek6Vw67zpthVw3XOA.webp"
  },
  {
    "name": "클라리스",
    "src": "_wm_e-FOjZtjhiC43MQluyvhRaWgkmNljlXMO3fdoT3RB04zfmTQF9q4Q0WAxez7rl0JPUnqlXKm7wuVfePvBg.webp"
  },
  {
    "name": "사쿠마 ",
    "src": "Ao0vIeEDQ99HuNV6kABFLHfPRMfSVaHh3yXGYG_OH5DWJG-SC55g1ADGexkdxuZifuNiSsLnVp0KO2o6JJ4kFQ.webp"
  },
  {
    "name": "무라마츠",
    "src": "j_DB2vuxSExAALbq4LfkUqM5nxkUCNwGrG-2V3usPfmu0SvkkujcyChUpFXz3JNZ1fhTql522l2rUD_5_8p0FQ.webp"
  },
  {
    "name": "시라기쿠",
    "src": "IvMW3cWucnEv2ASbVuWPR9KEAupybnWYJDHq8q4KbFdztT4cTCV4VANdyX97gIFkbJMYI_O7Flc9XEnbigM7Tw.webp"
  },
  {
    "name": "하야사카",
    "src": "1JUQVhLI9KAMjkrRWxaPLjMVwUxad4mTrkrJ3qLN0Axmjdn8STvRA0_3iEcMf5Nyutciz0aF_bPJ0KrxXMX6MQ.webp"
  },
  {
    "name": "아리우라",
    "src": "-uTJCLnT6p4ZkCEtlPLQrGovQFwKgIkgLPftATi1vItOPvt44VuVgKgWVJnR2EBwI_XV2aotKc6tNQsGymjymw.webp"
  },
  {
    "name": "오토쿠라",
    "src": "yQahDxIHv2YRt_EyDYjmzG09Nzo-FZxPsNWnsClCB0WToJxu7of2NXWt5jsCXxbvXPnVc87HcfnZoN0uKaIFRQ.webp"
  },
  {
    "name": "하라다 ",
    "src": "Vh7oYJQb2kEOvowAHFlsZYMkNxns3i2kM9WmS108nGyFELiEtqkSMiA1x83Cg4UziKQYAiFsDTgHxGWiXJoCrw.webp"
  },
  {
    "name": "이케부쿠",
    "src": "ckXIxiB1lTUN0G_rAtQCJQl9UXpW50qEOKRXUWMZIrUKbkJPEfJVeaUAySkKD_z3xn5g3_OC_fUfbK26hrEjWA.webp"
  },
  {
    "name": "츠지노 ",
    "src": "Imsbuj8c1g1G7oyB_diH1xl4_nbP9JhmT9xeluSCRT05ADMGGoWe3z7iFwMc7JyWr7cYAM280i5vAzP3rbm5nA.webp"
  },
  {
    "name": "쿠로사키",
    "src": "Zrq2hzk1rgMtXykofJkOJyUDadZ5F80cxAJ7hHZsmPuHaYp1Nzl0fvkhAJ3yXzdRYOuR78u4d55t8_cbigHHzQ.webp"
  },
  {
    "name": "시라유키",
    "src": "iw_vGPq_nJpgd5pxMc7pCFWEc7P9rWztKI6zHRYumFE5KcU-sCKoTcbyJVkXXlFUKK6WztNfz_JtFJGFcn1GZg.webp"
  },
  {
    "name": "시부야 ",
    "src": "ngPsVNBkZ09pWiymh1aZObKmWScWyHew_SaYcD4HrZdSvcwgiI4hhtT4fxa9Y8wJQ2Z62RvCXMR7b10TLI3xlw.webp"
  },
  {
    "name": "쿠로카와",
    "src": "xCY2R0IwXwnNcdR6AaLCo1_2hgeqVLgMYIx07u-mBPsSrB09-pCmg83uVejwkAopGQoX6zfER32ZXlXhjlWO8Q.webp"
  },
  {
    "name": "마츠모토",
    "src": "0IUvsdzLtN57xy6qeS2O0qRXnWWx9wtADcniWtd1Owr3GGaRLXaQH2ApEOrvbWARNQhPM4K8lkK2xfTcXfHGWQ.webp"
  },
  {
    "name": "키리노 ",
    "src": "lPgzeWq_kq8V1XqrnSr-iahvPIEcCAZp4osz0xwA_FUsY4IZdhacnpaqa5wRBPM3v9OAqYCbaLkP3hNrPdTJOg.webp"
  },
  {
    "name": "타카하시",
    "src": "rwMeBftnr5hyzY1BCGibfAcmMKyWkOLVO2XDUlVCNtmZrzKISFowJ1TQ4TevCgbefIbZXEOLvmUHEltjdzDVQQ.webp"
  },
  {
    "name": "아이카와",
    "src": "u8o9I4aFE-_lQEImKBe3HeeZEib4a64VQZMmIo8LYuXPZa3SX2gRFMm0jxBgTUoQqrkRvjlGWtdE6Bl_INU3MA.webp"
  },
  {
    "name": "카와시마",
    "src": "VIGmwTmQtXajtrbHklN68hqchXFs1RCUQsrUMlgDjOzzxHK8IGxwCuhnQZtWn0ixHpsmoEeyhIGRJqlExvmXqg.webp"
  },
  {
    "name": "카미야 ",
    "src": "DUlta4qHWI2CUrrd5yM9g8CNQMt_nSiscLwC3fx0Am287EpRo5lI6z08GsqnKJwvT7qFHSVowpeev6zkLj5CrQ.webp"
  },
  {
    "name": "카미죠 ",
    "src": "OGQ20ZQ0fPHPzGtA4RUzQ2YDIshu0AJw8rruNWee5giZ2p626wKmoAuqam1N8MYEMXj3OU2P7lMkNYSBcBA2Tw.webp"
  },
  {
    "name": "아라키 ",
    "src": "3La4YdHs0kH9-thteRp58zAuji6TgbtWUDgYiNKqGY2O17X3Hy6QlIHkgVvmK2WDmxz0eg-1qrRpXs1agNgrUA.webp"
  },
  {
    "name": "토고 아",
    "src": "EiNDYpWWopZg8wE8LO01ZJLSsU_BnAsj-S7Cne5lTXnqHitmWVqk9u24uI8m8w3DmjF2Tx5jirNc_BuqsjKKng.webp"
  },
  {
    "name": "타다 리",
    "src": "x4oDG6EYd3k0DxPX0T1iSSZOtDK_giQ32uz6uZpcLyBG7kumenEVwymoyR-vjyf1OCJm_fJtwdTEPeyJ8Po3SA.webp"
  },
  {
    "name": "미즈키 ",
    "src": "aV68pUDt1CJsq9x4E5Yz_yOD6SeqmrIZYqOIq2C8ERQczWXlk9xZZdjkGVgNwTIX41wSsZ8_0qylQGGiHKfqhg.webp"
  },
  {
    "name": "사사키 ",
    "src": "BYUEKRrD9B2Pn5Q3hkOF1IJn_2NTWYtlgXXhWCheP4IOHaG_H9BHUUiyj4CuE0RF62K8bRzibIWiTnKnUJ4zrQ.webp"
  },
  {
    "name": "미후네 ",
    "src": "ersX7cC3U4N6Aq1Pm6Rh27ld2mNAEEWLiN3cCq6Ml8SuWcJdaevd7NAXhK_aGCY4SrnoVFhThvCkB2poYNjn9g.webp"
  },
  {
    "name": "핫토리 ",
    "src": "R4PiE4eZtYr3rO_CdAdycbysy2UEcNdxR7kwtCEITzaxGdpRZlRe6shGnlRJG8jTAUCyRwp_-DyFVymwu9W4rw.webp"
  },
  {
    "name": "키바 마",
    "src": "YAEJCRdtpUfaUuShkI6E7ULIBQgr5IcHb16PRoLvQdFcv12TNV2e0UJkw1L5815ZbnEucmFADWj976xm5lA9fQ.webp"
  },
  {
    "name": "후지와라",
    "src": "5OZUOprzQROEpxondtGulX0Q8AMGQI1ybIfBTg21jwL3oiGZ56h4epRyqeuy1iyApVraaNs-XkV9ZqzFnnCrjQ.webp"
  },
  {
    "name": "닛타 미",
    "src": "27EzUQHpCS2Z1nyJ3IJqtuvTjyaMMmP3UxnMx01jpF4hHIzhx9dx8qDdbKBX_CcAy93yZwl0qNhskmqHMO37oQ.webp"
  },
  {
    "name": "미즈노 ",
    "src": "z8eX5YdjNCDmMhbpWswmksjP0InhdvwaIqLFHJcWXtIefS80nECElXjqrn3icxhAbwICa_wV1Ul_NCgzV0RfMQ.webp"
  },
  {
    "name": "후루사와",
    "src": "WNznuBGiH3P0dRd288fq9pxVPYHP54mqPv-agTKtN77YJNXA9U01YHPVC5avRmDJ4y4jkH_ghxMnwd4RnkBo3g.webp"
  },
  {
    "name": "타치바나",
    "src": "kRxdmdqLgq4f-oHYc7F7ZRdoKso5632uCUEij-xzn4ZZbkVGIwfqkqfakFwdTCIP6Si3YHwmEhmV64Q0PjA1DA.webp"
  },
  {
    "name": "사기사와",
    "src": "1J8z6KjhuOO8bti-TQNMQNOxQE8ZoQB83RUQGfuGLkNO5TTBmPP_yaVkyG0gLaB_8M6z4Z6IJgPEleqUSTdYGA.webp"
  },
  {
    "name": "야가미 ",
    "src": "KBWdLeLG2FMyXwP6dN7KGuCkwPL-vg_zcWO7ZTvfA6cru5iEZerLsPU1r3drgPhINGyFGAk8XKtT5CYLci8WHg.webp"
  },
  {
    "name": "라이라",
    "src": "67290R7J3weRfdAbuocZor0GFBDJosCD0DA3eUXV86wHSRGtNLpraSFHnPPBL415LLUCcmCiW34yQM1cSbeoSw.webp"
  },
  {
    "name": "아사리 ",
    "src": "pcTSJcbETDFMGLNjGhDmGoPLXkestQFAdtLAf4tGzvvdBIBH7g5hTb1rY7uz-n61aJn2wwE6f5c5nWhmTDKz0A.webp"
  },
  {
    "name": "헬렌",
    "src": "nQg5gJYSHJg1oYNSHmYpkxhLvAP7HDM73f1-NyTSHTPj-ZATiDBCYSxasz9o0jBedBsvrJzRe0HswDMdLDNlMg.webp"
  },
  {
    "name": "마츠나가",
    "src": "5dMfJK9uvYDopUSijbfgnuu96JVuuvwixeaYcnBZ6JNHktJfYJ4imdscIYhqzYe27Z9qJzkGewUuwtyVXXrV6Q.webp"
  },
  {
    "name": "코무로 ",
    "src": "AsVIGQtWsXKcM7AmCGQ2xViYgpbbYnTaebBWXCo_s3hwfH9ob3tY6dULcYxNbgXat20XkhKO8J4t6mMjpN8Dkg.webp"
  },
  {
    "name": "타카미네",
    "src": "pQh4eVNQwTW4iHEyW6TPwYVTxDmbl47977DyY-fEEaWwn_NepPqqfL38_GC_qDTZ4nCXEJmDcK8zbpvzR_Lh6A.webp"
  },
  {
    "name": "타카가키",
    "src": "qidztfnttpkIp_4N7F7Bi1YE-n6YWORSnGzp_gb-2eAyvKgY-3crwkgYz6-KfMxmXreDpDnXiz0gklvnH7Fu3g.webp"
  },
  {
    "name": "칸자키 ",
    "src": "VxIPDQd5Xb6fbV3BlGUNLnubcS1CeueoN3NyB2NJnkIP6cfuM7ZrYi4B7fnDQvKr1WprsrazFdFHZQU8sGA-fw.webp"
  },
  {
    "name": "이쥬인 ",
    "src": "p_G12Ri9mSB9tfWOiBodiHWtHAE2M_4gJrXSMFAvDttg1bv4rc0qO9ufqqVHzksbPpr9J3onDDdupmYCLWwHDA.webp"
  },
  {
    "name": "히이라기",
    "src": "_eocaO4EtnnwdxQDBgaJKuQwVD-nA07mQ4FiG_tSUgXVZtv_ypYk6-4fIrJuC8q2eQtetshxvEzWAvCrd4QEqw.webp"
  },
  {
    "name": "호죠 카",
    "src": "aNbsySiFsRQbcEVpNU-xVNDGrgFVehqvpoiVYxDa4IOwOzQdlE864xuDkbx_7VwxH3of9x99EwhNL3uTs7-BnQ.webp"
  },
  {
    "name": "케이트",
    "src": "S0Kj_FrGk771wW_BBpyhiyaM7Z4doNFXWQDEdhmMPvepOWM33THkpQh0QEyFt9DVd19Y4-17Ay9tIGIxN-7qYg.webp"
  },
  {
    "name": "세나 시",
    "src": "OXArlzml8kzd2fFeHMImTmtQ902mSdhhfB7BW9c2TGFmPQChmhgDCQRJ-9p8c2PcWuPlM0huj1PUVUtTVIpCrA.webp"
  },
  {
    "name": "아야세 ",
    "src": "yVSypF5MAQuo-TjobSgNW7E_JjahPeUj1vBY3yGLoFBosU2Saiwa1LKwPsMwg6mxGl-KC-xy2VYobsEeJ3zCTg.webp"
  },
  {
    "name": "사죠 유",
    "src": "eucEldCi-2QitZ0E8BqDBb-3NUqCE9Vjj9X14wFrIPKiI2QWWhhRTOWnJ2fE8qvOhHPGgJ8M_Nn04TkYSWR5fQ.webp"
  },
  {
    "name": "시노하라",
    "src": "tqDb88YIKXXKJv6f8bdJ2KnnKxmqikpOzuZPkywS9VRSAfIB9tRFrV6Ug7GOGx_UVnqT53VXzqq0MQcBie80xQ.webp"
  },
  {
    "name": "와쿠이 ",
    "src": "JENp0a8dpa8lQsGuwXYNme9SYYwDg29pIw0b_Q3XGaVmw4UmLqqcpRni0Y4PlSC-bMsxPMPpEkragkFXNnUC-w.webp"
  },
  {
    "name": "요시오카",
    "src": "2FOq1tedKY8HQh0Vhny6eGGHhfciUsqG1_K-AXgRZpXhKljfHoNZA3pF2NJu_EzIDmFHkXZM-GBP13UF6-XiGQ.webp"
  },
  {
    "name": "우메키 ",
    "src": "AA6ss4z2bx4MLReak2jIyWxA8LXKEHq1pztVWiCqod9midF0zUe_U7gKWrywUT85CaLGXCGxzp1DtYjYjZwloA.webp"
  },
  {
    "name": "시라사카",
    "src": "U2bJL5cbevGIALYSZZ7yC5Vt34MY7iwcshWQkpAXirZHz--aBl62piLo_DL0QuHIyg8juwPbrTsbINVvyGAkvg.webp"
  },
  {
    "name": "키시베 ",
    "src": "o4iSNKYOYxls2PnErlIPBVN9JP0o0oZ91n4lSHtPOFInoDkQszVfyEn1J-y0J5d_-6E_7ASgwtCiQ8OpfSrzlw.webp"
  },
  {
    "name": "우지이에",
    "src": "xNqSGnsVqMXP0yaShe4gLh4CJozaOwqVgGQ3BuV0hzQQOSDqoML87ANmNBgLo1xePN-feBzC-wyKKB5GhLn70w.webp"
  },
  {
    "name": "니시카와",
    "src": "TapdS2ZLimIt7ND-gc9qLnt5HbxJLaHwVQ4iZttdV0MJ2Hw_m_Ly3MxC7VtHasx3rWdeObg1rLrl9DgH8QFsVw.webp"
  },
  {
    "name": "나루미야",
    "src": "q_pzaas-AvnRSSP7URp_rvGYQ3zE0w9q8Mk_iiWTa_zf_GsPv5en2ob2nSWGxTi1Ylilhi0ndB0nQzX-VOyhHg.webp"
  },
  {
    "name": "후지이 ",
    "src": "jpT1Nx8GeNM710u12x_kO2_kJ5dUU9q9Op1Oe42UtZrgVdfWbUDwX0yuy9cpUjQJINu2uJtdPsT27EbmMECCDQ.webp"
  },
  {
    "name": "시오미 ",
    "src": "dyPyUp-xJNGzuc6x32jc0Jki46UlcgZdmiAudpETUQqEqpHngILXX-vOzG5HmrIf-LCQKRAlp2gHyB5TD-yVuQ.webp"
  },
  {
    "name": "와키야마",
    "src": "DpvGeixys8PpeWdXa34zNrD5Oqf3KH4idG-FgQYYgyKrVq_eVW7cPoiYv4mfOt75jZmOHKKMoJhEWKWPzaKKCg.webp"
  },
  {
    "name": "오카자키",
    "src": "kMpc9dG63xO5ZAWih0Xh2A4UYStyKEb6ZDujPwzYNTEcxK2UAlCVSTBarxdt7afUg3rP1Apnltfuz_2dMiZfvw.webp"
  },
  {
    "name": "하야미 ",
    "src": "tQKqwAAW8Kh0wH_Pdpzig5993rfhO0gBzxowN2GXpH8PagHMBP2UMh-XaLV9mbTSghytrhedXAChUNtHodqkVQ.webp"
  },
  {
    "name": "오오이시",
    "src": "JTUcZ66aIS12hue4hKBQdZ7bxDSai2Kj614D9TVx3QBYOz1Gjz4C53QhbEo9Nwa80Gx6oIT0ge-YszGqqAYi1Q.webp"
  },
  {
    "name": "마츠오 ",
    "src": "yFnbVyqzRdaadPy0c8PprlR0ncRobPMPihyIR-2M1bSYvwnb0FQkpKi4EkjihdEE_gSQ7sVGWLP9PGfjRfpVLw.webp"
  },
  {
    "name": "모리쿠보",
    "src": "rAhq44WTdpHXEPlcdCqg_GuSCoWNWrnYuTFTAK3wT8OFhcOwszdzAULlCdguwa_Wt1mqcqso3u2u0hqqe_rfPA.webp"
  },
  {
    "name": "아나스타",
    "src": "LwYET_6HvXEe2e3u2a_NoUbsMEgf99YXW-y1NQ87acTvesnm8WetKfzc1i_U3BIgBYigXZ9ujq2XJ-1W5ObscQ.webp"
  },
  {
    "name": "야마토 ",
    "src": "KXhRLGTVdsfs1upqvpw2H1R8mssFNSQUfBsfkwwKNba7dBZ40uhLr-fzlTnn8GcamKpAY0u59h9IV7X_XVa8AA.webp"
  },
  {
    "name": "유우키 ",
    "src": "WFCQd1ufta2CLrOtDv6m6JvVtfrdBa9K2Vxbr24ZYNcn5-EobtSEUUEfruQdEyYWpt95kh_BHv0o4nuTxe6wQw.webp"
  },
  {
    "name": "니노미야",
    "src": "MrEWcSH4FvJzw6zg2tcxHR0lztoI161-2155K5J0Kn3lsbx2Zsij2wIV0755b9-LljO_S-XjAbuvqSFtPBy8SA.webp"
  },
  {
    "name": "키류 츠",
    "src": "t5nIsL3ZUtZzIpxcFGMu56AlcDm5AdeNbEyLv0oGna3onX-EXQ9RrUxdESwHk4D8USlxN5BkSFRorTLxA81LJg.webp"
  },
  {
    "name": "모치즈키",
    "src": "Gtl-UxDQ-K2UUhL0BG0paDuYoBniXw8gSphJqfa0GfFr3M860pvfRp7sd7rAJKi5ODnu0iKrgCjzhQv3l4GdBg.webp"
  },
  {
    "name": "타카후지",
    "src": "ZBp5l-_7A60HqMfRJBkBuIagI9H-dmvO_uhpt9PsNAFByptOMdDYdUQeUaulQKtLKckRLbYzCCpjjUxnz1bcLQ.webp"
  },
  {
    "name": "스나즈카",
    "src": "QRr6MUESQHcw6vjS6FDCjmcvCwQj0_sqzfdw5euyhY-JY6-UxiVify7XDBtJTAqq0cbKNIujjpX3AtI9g5KbCQ.webp"
  },
  {
    "name": "히사카와",
    "src": "uDITf-3NClT71qh_MXb81IQuqEQLDcgJpV7n49rm9_TDIeuJWqAimo-e4yX6tEyOuxIouhzcYfxjREMHPwAYXA.webp"
  },
  {
    "name": "혼다 미",
    "src": "DJpeo3t7WoNSE4z2vCkKOxwMUvzwe-jalPhhbhIC-eaw4OVljg1C10Mpp1OYKC7guCmpOx7MYOqJA5hajZu7Aw.webp"
  },
  {
    "name": "타카모리",
    "src": "2Z2zfSgT1bOZ-SoBe_u2LuLjcPsPLfC3F6b6_0Nv5oqFLouJxpumERj67gkUDlTjjb6EXnDZ0myb_rg9IlrbJA.webp"
  },
  {
    "name": "나미키 ",
    "src": "5v0MJFd8NXc0CI5dBP0t0P7G-JQzf6OhQhv0nMbqqlFaTUebyksjfsQ8C84Qnylh_6kOs27RPg0oBDrhYiy0Ag.webp"
  },
  {
    "name": "류자키 ",
    "src": "NevkiUCS3cynyFg4v-wxUPwXEUEjh50DCFzoqmDagTWZLYMHz-eY3mVOGlVHXQpFfZKx7c64iT5K6wt_CPBSvw.webp"
  },
  {
    "name": "키무라 ",
    "src": "Pp8FOYqkt_gYVvki1ZujBLGE0iEbZeGWjpsTKGbiiUnpfKTuwgmZiYIgjUKMxEn42q9vIdqm8OoZSpW8S5_yFA.webp"
  },
  {
    "name": "마츠야마",
    "src": "_nF00aXn6QuptNDw_u04EcUFgx2LQOxSfJwl8_97MoZoT9F2FqqFcoGV2wRp0K4Tbb7YTIuHzblFGKyXsmlVow.webp"
  },
  {
    "name": "사이토 ",
    "src": "t-QXjMlI-2RDcZrS3e0CNSO38LBYnG7fNMfHxYacFEgBkcTiu77ayxng-nx_iiv-Pw7t-tCPfrT94gFZHC4ZMg.webp"
  },
  {
    "name": "사와다 ",
    "src": "GoYtaMmK5xVmaKKD86jax-a4HjTtYS3ak3SqhdCboYrzukrmjVupvcEgLofrdGMoI90-8Wa5su46kbGKGbX1nQ.webp"
  },
  {
    "name": "야구치 ",
    "src": "S1MJr3HX5NREz2x11o0t-X5rsjvKuMJjoURnsJtXSwPVXyyMq_bRLJaWUEJGyoSq24HS76pJ5rimFao-MPEWyQ.webp"
  },
  {
    "name": "아카기 ",
    "src": "SxWFMns1dD7MzFylAQjeP-NXRnMa2Hx4q70N31Tju6lyGa6QUMDftxn37UmTIu48YHJyxHQlgyo-WvAdi2wGnA.webp"
  },
  {
    "name": "아이노 ",
    "src": "ChP-sqpTcgCM_JGQpSg3rpf6Q0F-787CafsuT1d6RN-ttQko1Nt3u8Nm1yLuOhkDb-kJCrjA1JkiPgA63KY3RA.webp"
  },
  {
    "name": "마나베 ",
    "src": "R64xtKM-crjMexW7SyLnkEWPuEu0PY-7XmIj5LaEjLkaWjJEifsvxMO0VkzKPtJcJvqxh_6QO9iw1aWck3LNyg.webp"
  },
  {
    "name": "오오츠키",
    "src": "9xFD3DvZUkjbQa9FT43w_DCdtot5EdXn-_8ix8tXWpAFfQwNDymtuaEPYQ2wjSUc3SV3aKm-ceMFH_WhBL0DHw.webp"
  },
  {
    "name": "히메카와",
    "src": "upzuh-Qn83vx02ZY0mNZhDMETmqu93iT4UVFrDyeYD7FU2hvsMCSkWyBlGrZQ9Jkkmd1rJez2PklcPvX8IGiwA.webp"
  },
  {
    "name": "키타미 ",
    "src": "F49VxQVxOIbqNh2bHJV5nreLR_Fu2DyY7rX3uLONIoeUpfofAF1xmhbfTNfQ2o_N80MKn8BqTysIOb2fptO_7w.webp"
  },
  {
    "name": "우에다 ",
    "src": "cigdgm3lFKOyzQRLXJJVLI3T7rCAJcmfBjEwh1BnpwnSLJRmrzj6E8q0T5BfZrSy33CyDFCcMkTxa1Psu0hAEw.webp"
  },
  {
    "name": "에비하라",
    "src": "J1P9EGchjlogf6y4AEQdzfe2AAKBaGo22qzQP4Em1Hjg47Is_SM2crw9yVxFWlEtHXaqJL8awMuFJr7kR_b8hQ.webp"
  },
  {
    "name": "오이카와",
    "src": "vtT6ebnnV4V1GEySK7QOB7PboBrM2AyjMlX9_gFsI5RSEa4MmSvAGAP65rsCHQYevKV6b7PBXcFnJn2Ett5RHQ.webp"
  },
  {
    "name": "코세키 ",
    "src": "670iYw9o7ZHrIt537KWc82FK-gTWcKgo2G04YdbTR2M-xnWhluT0EkbRKUUqXR5ir54NBVjPTsrBUHHCpZvLlQ.webp"
  },
  {
    "name": "에토 미",
    "src": "nzp06DLRPiDTVUoQZ6s3AY6tOXlaT74CvO2ZTv58ewHxtBdcTi0mZlYPTm1k8HWLQzm3ngooGkTePxYK09zHww.webp"
  },
  {
    "name": "호시 쇼",
    "src": "wwhmIL9OFUz1dd-7VgI-QCEusZVdbkmc10-OFrX3tnxMn-0XfMSDhUx1zkZJMK837r0ln7xY7l5QsjgIjhgQOw.webp"
  },
  {
    "name": "카타기리",
    "src": "ohaN3lrrjIHi5i5TScJZ6tqqccl-SVuQ_WmwTKABu5r-i4ayhwNqJaD7hPy6gxRfDbmhqIS2l9MNObjQ1ToE5A.webp"
  },
  {
    "name": "í¸리 유",
    "src": "wDD8mI3iBY-BgpkFmfu8ci6lc1ooCVyIK7J69kasfbM4AUItjRHM3V50tERMa3AbtJbBbbrKxlyuWrzFgzb0Xg.webp"
  },
  {
    "name": "니시지마",
    "src": "0iAgtZOe3a26dxIrMgffkN_EspRpyduQ7TJ1E9O621eBaQLoj5dxwn30GVTU3woy4XF46hgH3YvdADLzQrU8Ng.webp"
  },
  {
    "name": "마토바 ",
    "src": "h4QQrXF5wnX4T1GjZ2mzkNgWpaXFwIaVOKeJJd9vDTJ2oKv-nhhCtPJSBbd-5ZlD6ePxfInkF_3cBRjT-96NyQ.webp"
  },
  {
    "name": "자이젠 ",
    "src": "GVRJaO7s8MS7i9C8VCu6hP2eT0PJ6j23M4BnVDaxZhwBRIVCyHN5cLWlrZBGWrpK3UYXgZ-4SJPdeBmGmRzaJw.webp"
  },
  {
    "name": "요리타 ",
    "src": "u6vr4pDvDEk_Sy6D1BytK8paJZGDls9dPmSRhe4rb-1JBVS-ZTJawc65zUYCNzdriGNcRtJs86rrNEVOTtQ76g.webp"
  },
  {
    "name": "아이바 ",
    "src": "D3Ln1hJaQ42GsPBl554DH7VBnVVsI86Sw2LZrwOEzUu1MKO1fvPSMiOeZKnz4pv7-_EtkQ5ltaH8gwhkHHKDeQ.webp"
  },
  {
    "name": "노노무라",
    "src": "zkIN9aIN_mHirNTC8qX9TRBZEwjDXHaEEFe7POQzGUrFsdwZYGl8CF2rbyvgz5f9rA4ZGGj47VwWHV7QoYDEKw.webp"
  },
  {
    "name": "하마카와",
    "src": "vfoTUCJl59jvRcegRMUJrQvcrhb4Kn1hEjlZDb9Lk-7qbSe0vB57Uvma-6d6W7BXKDF0gtujchemFcHTqPR-Sw.webp"
  },
  {
    "name": "와카바야",
    "src": "HleHhsYk6_SWertSFvcFzAaUoX3l-nCac9io0ky3G6PL5qatzhtIJhwTZKgP7PoaI-LFX8q4ie-ISwuq91RvbQ.webp"
  },
  {
    "name": "죠가사키",
    "src": "sJ-br-yYBljhjvDyzJxD5X-SxrS1Uiu41usMj7Y09ifbxrfj3eTufm4Xh_LX87BtVAuvSI6DogJywm2ETK6GcA.webp"
  },
  {
    "name": "죠가사키",
    "src": "WSEbz5F5w2-I4984JufcUldqX536Xv9nMmGQo--j73MbHuaXF7mv-uAr0Db_-Qpj0msVcd9G9hd44rJEsdoVgw.webp"
  },
  {
    "name": "센자키 ",
    "src": "21t_So0ka8s9PVrkcItXYrKr9i_dFqx83fnm3QroQtJ4_jvjf8o6WB4napVCA1z-Ikg2hqz7pw9lvmmkJFBT6g.webp"
  },
  {
    "name": "히노 아",
    "src": "KLP8PjQmIqvZHKWIBD_Ypm9NIAA_OIXbyNOlbO-QRcmONFrQXYMu-AqAwBprRSZmT8cfirx5a6BtNcpF2aAq7Q.webp"
  },
  {
    "name": "모로보시",
    "src": "eFdqHDGxBRdBHWX4ZS-pBStxi3d0y4_2VwoWy4xsTRoq-NkbBZJUeRznvgh3YmtYpfZY70pxwgG27iUwbIRO4g.webp"
  },
  {
    "name": "토토키 ",
    "src": "fQY-5IOVscyY6RcjwafQUgo64MA4-_UeQka5Tga_oIBcmQQEPv9HaWYIWNvzo2feTvURIxgw8wWK8_n4zL2I4A.webp"
  },
  {
    "name": "나탈리아",
    "src": "CxwI_9GCk1WNhzh6Fub_mPStH9kA4fur7ngt_jKcwN4Nr4-FCuuZ4TuuoFivVFhvuo4G24Q9s5UshwTb3vdyKA.webp"
  },
  {
    "name": "소마 나",
    "src": "QrOS_9M2bHatoWZmY_PTkX0mt1jS37nh05Aysoyx_vm0p1mFWA-yXL7WI0dATcc2vPoNWqeyK6gxWHwb6rMjWA.webp"
  },
  {
    "name": "마키하라",
    "src": "SNRAG4QYm9m9qYmgIbVSCP8SezEhL7w-gh3O3c0qbXuJ_FIE6OCW3irVXtXJbwZdBSkjgIGpFMqGBXErsZ5stw.webp"
  },
  {
    "name": "무카이 ",
    "src": "oiFoycTuWj4liuU9hLnQoNPCTMZYD_j8G8oWml3pjYvHMfxlBYjV-D7UnpByGn_GnKCOqJDj9Ua3NMMo_HZAkw.webp"
  },
  {
    "name": "이치하라",
    "src": "k-Gg9Zvxu8ZrRnYblHGrwq8wD4bmDgUoFflhITbGXaXDKR2x7NRhBDzCgMxv9PquFFdZhWX_W3pwXPIcdAzRNw.webp"
  },
  {
    "name": "키타 히",
    "src": "RmMvV6WdnPxp50cRPwtFzToLuIxhlQoka-ddJu38SO34WQaQcoPbZuULBKDsgneWBQVNYiPxh-XVrZjtnAUHpQ.webp"
  },
  {
    "name": "스기사카",
    "src": "RGEQUSLu1i7fdoW-nueyzTREjIYl1B9LYUT0oY5OCyF-K7rcB47cN2oGY6KjWO4TvQSDgYmJlfU65U8WR1SQhA.webp"
  },
  {
    "name": "키타가와",
    "src": "yyNFh6HzYRpLBYJaDbXsXf-zVWFRkbm2tgHqs6nEzT49uDfx4Pd7YGUNF_gBfm1_x0iqnhIYrk3P6MWJCvaxaA.webp"
  },
  {
    "name": "메어리 ",
    "src": "-sYRTcrzfgJYfVSJ-VCUb2YVgOHiFUHqzExalZbRpHsapCiXqw3PmFMg3-VL9V4Mn1M7zsEy05L1twSqoesvrw.webp"
  },
  {
    "name": "코마츠 ",
    "src": "hc--yj-e-UsSOnIfZ20u60S44n45AXaZm72d0ftbcOp7dlL3s8uQlI3vbLjD15B21hPPWtGsQ2Qn8vW5KpL8vg.webp"
  },
  {
    "name": "미요시 ",
    "src": "zdT7aDBnZ3L6dgU5KREMn5Vd3S-7PP3gasXjiX2f-e2bzPcsrjlDtrHOLdVKp1v7OV2ri-0-YZBtH7mI6Dpp6g.webp"
  },
  {
    "name": "캐시 그",
    "src": "OS6Iuu2HAAH-GdNUCY-DU2VinMtY-dNM5D0iKRx9XaRkcEwnJyp2NRaDdhrKx-DtNBHL1cgcnUwtjy_DfQXv_Q.webp"
  },
  {
    "name": "남바 에",
    "src": "3HEQXA6LLq6LLTLciv_8iLqCbUJCOobpKG5GQmXmebwjkHpooFzr1n-m3NskGaBXBvo5eEcpN0fM_-a0fuDHmQ.webp"
  },
  {
    "name": "하마구치",
    "src": "I3aoi88bqBdLbnyu6_rmlHWMt7lYcshtDl7HF252wG4DlwalUdj3w13ryULPFBjSpnuKCtAvixD5MJYWVo8IXw.webp"
  },
  {
    "name": "무라카미",
    "src": "dmD32ZaULKBLrHsxqaFDjzjYVsspv6E1ly7uo0OgZTPLf_cXogvP9Ymp42RhtN_Xl-VqzVU08HpzISXu0VRs6g.webp"
  },
  {
    "name": "츠치야 ",
    "src": "IbKWf3DbZKAg40oYVKAehqyffN6kq8hR-oee_D0wWul3LF0C9c8go8L8Sa_LjwlRAzCOe1iAK0US8vWZbsNDdA.webp"
  },
  {
    "name": "슈토 아",
    "src": "Z4No5lHK0Zc0I2oWCeYUt-MZXwvjgFakGei4EsFHCbihha7ZVfij8O7Bp2o44vW_pVSDVh36yTbJxoFFu9T1RA.webp"
  },
  {
    "name": "사에지마",
    "src": "H2VVRBxcc2qA5mLlHAxjP2kLE2doA-onMDBAdjnbOj8kmmZLJCwC10NRvAnzAnm_igkWLI0txKz9PFld31sx-Q.webp"
  },
  {
    "name": "사토 신",
    "src": "0A4-2Q2Cwmuh6HdC-L453sOpgPmz16tzVvvujN5zExoh9TBRK5PhnsTPLkyiGaFsKB8ZZ2Utnn4tfX6kZK_EPw.webp"
  },
  {
    "name": "난죠 히",
    "src": "tly8TpFtTUhashIvZ1o9LRawtrpoxPF-g8IEDU8jAwaw4blO59Y_M_d4lrLVEy7lDH_bIDDWMY3K74Ck54GpBg.webp"
  },
  {
    "name": "이브 산",
    "src": "CgpGfr1Pa1qU7gV1LgZfErL-3YRP5SxvX38LDQTenRNCSucEZKtxvfXITTdeamM4Z2Bd6NGYKeltIYGERMHSfw.webp"
  },
  {
    "name": "유메미 ",
    "src": "GQsRmALsQxXs4WLK8AMnpo7ZbxX4Bz3lnbiteiAG6i0J19bljg4uwrN1mBLntxGiVOUFF0xFafhXLriUwNgXSQ.webp"
  },
  {
    "name": "히사카와",
    "src": "tB6beQEKDEmJAxhyomxCsZ2SUHmoelaDnXaUtutGQP5u9dosE_Iwb-2uzd9o4dQLs5D6DR-4QQbF7gvWkwY1MQ.webp"
  }
];

export function iconurl(name) {
  for (const item of images) {
    if (name.startsWith(item.name)) {
      return "/thumbnail/" + item.src;
    }
  }

  const op = Object.values(fixedOperators).find((op) => op.name === name);
  if (op?.name === name) {
    return '/' + op.portraitUrl;
  }

  const npc = dialogNpcByName(name);
  if (npc?.name === name) {
    return npc.portraitUrl;
  }

  return names5.indexOf(name);
}
